import _ from "lodash";
import ACLStore from "lib/aclStore";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
  CURRICULUM_TYPE_UBD,
} from "Constants/stringConstants";

export const PDFTRON_AUTOSAVE_TIMEOUT = 120000;

export const PDFTRON_ENABLE_ERASER_FLAG = "FeatureFlag:PDFTronAllowEraser";

export const NETWORK_ERRORS = [
  "failed to fetch",
  "network error",
  "load failed",
  "timeout of 0ms exceeded",
];

export const PDFTRON_DOWNLOAD_BUTTONS = [
  "downloadAnnotatedWithoutNamesOption",
  "downloadAnnotatedOption",
  "downloadOriginalOption",
  "printOption",
  "downloadPageButton",
];

export const isNetworkError = error => {
  const errorMessage = _.get(error, "message", "");
  return (
    _.get(error, "networkError", null) ||
    _.includes(NETWORK_ERRORS, _.toLower(errorMessage))
  );
};

export const PDFTRON_VIEWER_MODE_TYPES = {
  TEACHER_EDITOR: "TEACHER_EDITOR",
  STUDENT_EDITOR: "STUDENT_EDITOR",
  VIEWER: "VIEWER",
};

export const getFileKeyAndVersionFromToddleUrl = url => {
  try {
    const { pathname, search } = new URL(url);
    const params = new URLSearchParams(search);
    const version = params.get("v");
    const newVersion = _.isEmpty(version) ? 1 : parseInt(version) + 1;
    const key = _.trimStart(pathname, "/");
    return { key, version: newVersion };
  } catch (e) {
    return { key: "", version: 1 };
  }
};

export const canEditPdfInPdftron = ({ curriculumProgramType, grade = "" }) => {
  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_PYP:
      return ACLStore.can("FeatureFlag:PypPdfTronPDFSupport");
    case CURRICULUM_TYPE_MYP:
      return ACLStore.can("FeatureFlag:MypPdfTronPDFSupport");
    case CURRICULUM_TYPE_DP:
      return ACLStore.can("FeatureFlag:DPPdfTronPDFSupport");
    case CURRICULUM_TYPE_UBD:
      if (ACLStore.can("FeatureFlag:UBDPdfTronPDFSupport")) return true;
      return (
        grade &&
        !isGradeLessThan6(grade) &&
        ACLStore.can("FeatureFlag:UBDPdfSupport")
      );
    default:
      return ACLStore.can("FeatureFlag:PdfTronPDFSupport");
  }
};

export const shouldConverPdfToWorkbook = ({
  curriculumProgramType,
  grade = "",
}) => {
  if (_.isEmpty(curriculumProgramType)) return false;

  const isPdftronEnabled = canEditPdfInPdftron({ curriculumProgramType });

  switch (curriculumProgramType) {
    case CURRICULUM_TYPE_PYP:
      return ACLStore.can("FeatureFlag:PypPdfToWorkbookTemplate");
    case CURRICULUM_TYPE_MYP:
      if (isPdftronEnabled) return false;
      return ACLStore.can("FeatureFlag:MypPdfToWorkbookTemplate");
    case CURRICULUM_TYPE_DP:
      if (isPdftronEnabled) return false;
      return ACLStore.can("FeatureFlag:DpPdfToWorkbookTemplate");
    case CURRICULUM_TYPE_UBD:
      if (ACLStore.can("FeatureFlag:UbdPdfToWorkbookTemplate")) return true;
      if (isPdftronEnabled) return false;
      return (
        isGradeLessThan6(grade) && ACLStore.can("FeatureFlag:UBDPdfSupport")
      );
    default:
      return false;
  }
};

export const canViewPdfInPdftron = () => {
  return ACLStore.can("FeatureFlag:EnablePdfViewModeInPdftron");
};

export const canOpenOfficeFileInPdftron = () => {
  return ACLStore.can("FeatureFlag:PdfTronOfficeSupport");
};

export const canViewCommentsInPdftron = () => {
  return ACLStore.can("FeatureFlag:PdfTronEnableComments");
};

export const getFilteredDisableElementsInPdftron = disableElements => {
  const filteredDisableElements = canViewCommentsInPdftron()
    ? _.pull(disableElements, "toggleNotesButton", "notesPanel")
    : disableElements;

  return filteredDisableElements;
};

const isGradeLessThan6 = grade => {
  return _.includes(
    [
      "Early Toddler",
      "Toddler",
      "PT",
      "PG",
      "Pre-K",
      "K-1",
      "K1",
      "K-2",
      "K2",
      "Grade 1",
      "Grade 2",
      "Grade 3",
      "Grade 4",
      "Grade 5",
    ],
    grade
  );
};
